export interface CampaignLanguageOption {
  id: string;
  name: string;
}

/** Curated BCP-47 codes: Europe, Americas, and Hebrew. */
const CAMPAIGN_LANGUAGE_OPTIONS_RAW: CampaignLanguageOption[] = [
  { id: 'bg', name: 'Bulgarian' },
  { id: 'hr', name: 'Croatian' },
  { id: 'cs', name: 'Czech' },
  { id: 'da', name: 'Danish' },
  { id: 'nl', name: 'Dutch' },
  { id: 'en', name: 'English' },
  { id: 'fi', name: 'Finnish' },
  { id: 'fr', name: 'French' },
  { id: 'de', name: 'German' },
  { id: 'el', name: 'Greek' },
  { id: 'he', name: 'Hebrew' },
  { id: 'hu', name: 'Hungarian' },
  { id: 'it', name: 'Italian' },
  { id: 'pl', name: 'Polish' },
  { id: 'pt', name: 'Portuguese' },
  { id: 'pt-br', name: 'Portuguese (Brazil)' },
  { id: 'ro', name: 'Romanian' },
  { id: 'ru', name: 'Russian' },
  { id: 'es', name: 'Spanish' },
  { id: 'sv', name: 'Swedish' },
  { id: 'tr', name: 'Turkish' },
  { id: 'uk', name: 'Ukrainian' }
];

export const CAMPAIGN_LANGUAGE_OPTIONS: CampaignLanguageOption[] =
  CAMPAIGN_LANGUAGE_OPTIONS_RAW;

const optionByCode = new Map(
  CAMPAIGN_LANGUAGE_OPTIONS.map((option) => [option.id, option])
);

export function formatCampaignLanguageLabel(option: CampaignLanguageOption): string {
  return `${option.name} (${option.id})`;
}

export function getCampaignLanguageOption(
  code: string
): CampaignLanguageOption | undefined {
  return optionByCode.get(code.trim().toLowerCase());
}

export function getCampaignLanguageDisplayLabel(code: string): string {
  const option = getCampaignLanguageOption(code);
  return option ? formatCampaignLanguageLabel(option) : code;
}

export function getAvailableTargetLanguageOptions(
  existingCodes: string[]
): CampaignLanguageOption[] {
  const used = new Set(existingCodes.map((code) => code.trim().toLowerCase()));
  return CAMPAIGN_LANGUAGE_OPTIONS.filter((option) => !used.has(option.id));
}

export function getTargetLanguageOptionsForDialog(
  existingCodes: string[],
  currentCode: string,
  editingExisting: boolean
): CampaignLanguageOption[] {
  if (!editingExisting) {
    return getAvailableTargetLanguageOptions(existingCodes);
  }

  const normalized = currentCode.trim().toLowerCase();
  const available = CAMPAIGN_LANGUAGE_OPTIONS.filter(
    (option) => option.id === normalized
  );
  if (available.length > 0 || !normalized) {
    return available;
  }

  return [{ id: normalized, name: normalized }];
}
